let cryptoKeys = {
    publicKey: ['-----BEGIN PUBLIC KEY-----',
        'MFswDQYJKoZIhvcNAQEBBQADSgAwRwJAXrLHMFBsXkF+mV7z5AtK9vHy+1y1YhGS',
        '4sn3Q4M9hzn82K80ROHBgrS52SoutuOXZdaYSKnSDm7TdI2YaF2OrwIDAQAB',
        '-----END PUBLIC KEY-----'].join('\n')
};

export default cryptoKeys;